import { Card, Divider, Stack } from "@mantine/core";
import CardInfo from "../Subscriptions/components/CardInfo";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { format } from "date-fns";
import { it } from "date-fns/locale";

const Profile = () => {
	const user = useSelector((state: RootState) => state.auth);

	return (
		<Stack gap={ 0 }>
			<div>
				<h1>Profilo</h1>
			</div>

			<Divider my="xs" label="Informazioni account" labelPosition="center" />

			<Card shadow="sm" padding="lg" radius="md" withBorder>
            	<Stack>
					<CardInfo label="Nome" value={ `${user.name} ${user.family_name}` } />
					<CardInfo label="Email" value={ user.email } />
					<CardInfo label="Data di Creazione" value={ format(user.attrs.info.createdAt, "dd MMMM yyyy", { locale: it }) } />
				</Stack>
			</Card>
		</Stack>
	);
};

export default Profile;